import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../components/ui/button";
import Common from "../../../helper/common";
import { FormikInput } from "../../../components/formik-components";
import { respEnum } from "../../../constants/appConstant";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";
import { Checkbox } from "../../../components/ui/checkbox";

const FormikInitialValues = {
  name: "",
  isactive: true,
};

const formikValidation = yup.object({
  name: yup.string().required("Amenity Name is required"),
});

const AddAmenity = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  const onSubmitData = async (d, action) => {
    let data = {
      ...d,
      id: id || 0,
    };
    let response = await Common.ApiService.getInstance().request(
      "AddUpdateMasterAmenity",
      data,
      "POST"
    );
    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      onClose(response.data);
      setOpen(false);
      if (!onClose) {
        navigate("/app/amenities", { replace: true });
      }
    }
  };

  const getDataInfo = async () => {
    let response = await Common.ApiService.getInstance().request(
      `GetMasterAmenities?id=${id}`
    );
    if (response.status === respEnum.Success && response.data.length > 0) {
      formikRef.current.setValues(response.data[0]);
    }
  };

  useEffect(() => {
    if (id) {
      getDataInfo();
    }
  }, [id]);

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
            Add
          </Button>
        </DialogTrigger>
        <DialogContent ref={dialogRef}>
          <DialogHeader>
            <DialogTitle className="text-base font-medium ">
              {!id ? "Add" : "Update"} Amenity
            </DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500  space-y-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                  <div className="col-span-1">
                    <div className="md:grid md:grid-cols-1  gap-6 mt-6 space-y-6 md:space-y-0">
                      <div className="flex flex-col gap-2">
                        <FormikInput
                          formikProps={formikProps}
                          name={"name"}
                          label={"Amenity Name"}
                          placeholder={"Enter Amenity Name"}
                          maxLength="50"
                        />
                      </div>
                      <div className="flex flex-col gap-2">
                        <div className="flex items-center space-x-2">
                          <Checkbox
                            id="isactive"
                            checked={formikProps.values.isactive}
                            onCheckedChange={(value) =>
                              formikProps.setFieldValue("isactive", value)
                            }
                          />
                          <label
                            htmlFor="isactive"
                            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                          >
                            Active
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </div>
          <DialogFooter className="mt-8 gap-2">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Close
              </Button>
            </DialogClose>

            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Saving..."
                  : !id
                  ? "Add"
                  : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddAmenity;
